import { Col, DatePicker, Row, Spin, Tooltip, Button, Tag } from "antd";
import moment from "moment";
import React, { useState } from "react";
import ButtonComp from "../../Components/ButtonComp/ButtonComp";
import LineGraph from "../../Components/OEE/linechart.dashboard";
import DynamicPiechart from "../../Components/OEE/piechart.dashboard";
import DynamicProgress from "../../Components/OEE/progress.dashboard";
import Stats from "../../Components/OEE/stats.dashboard";
import {
  oee_dashboard_output,
  oee_dashboard_shiftTime,
  oee_dashboard_stats,
  oee_dashboard_tabs,
  testFunc,
} from "../../Utils/constants";
import {
  cancelCircle,
  clipboardText,
  favchart,
  HiOutlineRefresh,
  maskGroup,
  messageQuestion,
  imports,
} from "../../Utils/imports";
import { HomeVar } from "../../Utils/variables";
import { useEffect } from "react";
import {
  getMergeFullDay,
  getMergeShiftWise,
  getShifts,
} from "../../API-Interaction/apiServices/kpis.api";
import { useDispatch, useSelector } from "react-redux";
import {
  antIcon,
  convertSecsToTime,
  disabledDate,
  formatDate,
  refineDateTime,
} from "../../Helpers/helpers";
import NoDataFound from "../../Components/Helpers/NoDataFound";
import { onDropDownChange } from "../../API-Interaction/apiServices/plants.api";
import { pages } from "../../Routing/pageRoutes";
import { changeShift, changeShiftDate } from "../../Redux/features/plant.slice";
import SupportButton from "./Support";
import ForceShiftStop from "../../Components/LineOperatorComp/ForceShiftStop";
import BasicModal from "../../Components/Modals/BasicModal/BasicModal";
import RangePicker from "rc-picker/lib/RangePicker";

const Dashboard = () => {
  const { RangePicker } = DatePicker;
  const [dashTab, setDashTab] = useState(1);
  const { current, lists = [] } = useSelector((state) => state?.plant);
  const { plant } = useSelector(state => state?.plant?.current)
  const { stats } = useSelector((state) => state.kpis);
  const [modalStates, setModalStates] = useState({});
  const dispatch = useDispatch();
  const { componentLoaders } = useSelector((state) => state?.utils.loaders);
  const [type, setType] = useState();

  const {
    pageLoaders,
    componentLoaders: { chart = false },
  } = useSelector((state) => state?.utils.loaders);
  const getDefaultWeeklyRange = () => {
    const now = moment();
    const endDateWeekly = now.clone();
    const startDateWeekly = endDateWeekly.clone().subtract(7, "days");
    return [startDateWeekly, endDateWeekly];
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    type: "weekly",
    range: getDefaultWeeklyRange(),
  });

  const getDefaultMonthlyRange = () => {
    const now = moment();
    const prevMonth = now.clone().subtract(1, "month").date(now.date());
    return [prevMonth, now.clone()];
  };

  const handleButtonClick = (period) => {
    if (period === 'custom') {
      setSelectedDateRange({
        type: 'custom',
        range: selectedDateRange.type === 'custom' ? selectedDateRange.range : null,
      });
    } else {
      setSelectedDateRange({
        type: period,
        range: period === 'weekly' ? getDefaultWeeklyRange() : getDefaultMonthlyRange(),
      });
    }
  };

  useEffect(() => {

    current?.plant && getMergeShiftWise(dispatch, current)

  }, [current]);

  useEffect(() => {

    getShifts(dispatch, current)

  }, [current?.plant,current?.line,current?.machine]);


  const getFormattedDateRange = () => {
    const { type, range } = selectedDateRange;
    switch (type) {
      case "weekly":
      case "monthly":
        const [start, end] = range || getDefaultWeeklyRange();
        return `Start Date: ${start.format(
          "YYYY-MM-DD"
        )}, End Date: ${end.format("YYYY-MM-DD")}`;
      case "custom":
        if (range) {
          const [startCustom, endCustom] = range;
          return `Start Date: ${startCustom.format(
            "YYYY-MM-DD"
          )}, End Date: ${endCustom.format("YYYY-MM-DD")}`;
        } else {
          return "Custom date range not selected.";
        }
      default:
        return "Invalid";
    }
  };
  const ShowTabs = oee_dashboard_tabs.map((tabs, i) => (
    <div key={i}>
      <span
        className={dashTab === tabs.id ? "dashTabsActivated" : "dashTabs"}
        onClick={() => setDashTab(tabs.id)}
      >
        {tabs.name}
      </span>
    </div>
  ));
  const onRangeChange = (dates) => {
    const [start, end] = dates;

    // Check if both start and end dates are before the current date
    if (start < new Date() && end < new Date()) {
      setSelectedDateRange({
        type: "custom",
        range: dates,
      });
    } else {
      alert("Please select dates before the current date");
    }
  };

  const onDateChange = async (date, dateString) => {
    await getShifts(dispatch, current, date?date:null)
    dispatch(changeShiftDate(date))
  };

  const exportReport = (
  
    <Row>
      <Col span={24}>
        <div style={{ display: "flex", gap: "0" }}>
          <Button
            className={`exportButton ${selectedDateRange.type === "weekly" ? "selected" : ""
              }`}
            style={{
              flex: 1,
              border: "1px solid #CCCCCC",
              textAlign: "center",
            }}
            onClick={() => handleButtonClick("weekly")}
          >
            Weekly
          </Button>
          <Button
            className={`exportButton ${selectedDateRange.type === "monthly" ? "selected" : ""
              }`}
            style={{
              flex: 1,
              border: "1px solid #CCCCCC",
              textAlign: "center",
            }}
            onClick={() => handleButtonClick("monthly")}
          >
            Monthly
          </Button>
          <Button
            className={`exportButton ${selectedDateRange.type === "custom" ? "selected" : ""
              }`}
            style={{
              flex: 1,
              border: "1px solid #CCCCCC",
              textAlign: "center",
            }}
            onClick={() => handleButtonClick("custom")}
          >
            Custom
          </Button>
        </div>
      </Col>
      <Col className="dflex justifyLeft alignCenter pt10" span={24}>
        <RangePicker
          className="exportTag dflex justifyCenter alignCenter"
          value={
            selectedDateRange.type === 'custom'
              ? (selectedDateRange.range || null)
              : selectedDateRange.type === 'monthly'
                ? getDefaultMonthlyRange()
                : getDefaultWeeklyRange()
          }
          onChange={onRangeChange}
          disabled={selectedDateRange.type !== "custom"}
        />
      </Col>
    </Row>
    )

  const handleModal = (task, type) => {
    setType(type);
    if (task === "open") {
      setModalStates({ ...modalStates, [type]: true });
    }
    if (task === "close") setModalStates({ ...modalStates, [type]: false });
  };

  const ExportButton = () => {
    return (
      <div className="dflex alignCenter gap10 justifySB">
       <Button
                className="exportMain"
                onClick={() => {
                  handleExportModal()
                }}
                theme="white"
              >
                Export
              </Button>
      </div>
    );
  };

  const handleExportModal = () => {
    handleModal("open", 1);
  };

  const handleExport = () => {
    const selectedPeriodValue = getFormattedDateRange();
    console.log(selectedPeriodValue);
  };

  const RefreshButton = () => {
    return (
      <div className="dflex alignCenter gap10 justifySB p10 boxBg boxBorder boxBorderRad refreshButton">
        <HiOutlineRefresh
          style={{
            background: "#c2c9d8",
            color: "white",
            padding: "2px",
            borderRadius: "100%",
            fontSize: "15px",
          }}
        />
        <p>
          Last Updated <strong>{formatDate(new Date(stats?.updated_at), "hh:mm a")}</strong>
        </p>
      </div>
    );
  };

  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.oee_dashboard || false}>
      <div className="oee-dashboard">
        <Row className="oee-dashboard-row-1">
          <Col className="oee-dashboard-row-1-tabs">{ShowTabs}</Col>
          <Col className="oee-dashboard-row-1-buttons">
          {stats?.status === 'shift ended' && (
    <div className="shift-ended">Shift Ended</div>
)}

            <ForceShiftStop />
            <SupportButton />
          </Col>
        </Row>
        {dashTab === 1 ? (
          <>
            <Row className="oee-dashboard-row-2">
              <DatePicker
                defaultValue={current?.shiftDate || moment(new Date())}
                value={current?.shiftDate || moment(new Date())}
                format="DD-MM-YYYY"
                disabledDate={disabledDate}
                onChange={(date, dateString) => onDateChange(date, dateString)}
                className="eff_datepicker"
                allowClear={false}
              // showTime={{ format: 'hh:mm:ss' }}
              />

              {lists?.shifts?.map((shift) => (
                <Tooltip title={shift?.range}>
                  <div onClick={() => dispatch(changeShift({ selectedShift: shift }))} className={`shiftBox ${shift?.name === current?.shift?.name && 'shiftBox-active'}`}>{shift?.name}</div>
                </Tooltip>
              ))}
              {ExportButton()}
              {
                <BasicModal
                  id="1"
                  title="Export OEE Report"
                  children={exportReport}
                  btn1Text="Export"
                  btn2Text="Cancel"
                  open={modalStates["1"] || false}
                  handleOK={async () => {
                    handleExport();
                    handleModal("close", 1);
                  }}
                  handleCancel={() => handleModal("close", 1)}
                  loading={componentLoaders?.export || false}
                />
              }
              {RefreshButton()}
            </Row>
                        <Row className='oee-dashboard-row-3'>
                            <Col className='oee-dashboard-row-3-col-1'>
                                <Stats />
                            </Col>
                            <Col className='oee-dashboard-row-3-col-2'>
                                <div className='availability'>
                                    <span style={{fontSize: 18}}>Availability</span>
                                    <div className='availability-progress'>
                                        <DynamicProgress percent={stats?.availability || 0} color="#1E6EFE" />
                                    </div>
                                </div>
                            </Col>
                            <Col className='oee-dashboard-row-3-col-3'>
                                <div className='performance'>
                                    <span style={{fontSize: 18}}>Performance</span>
                                    <div className='performance-progress'>
                                        <DynamicProgress percent={stats?.performance || 0} color="#ED9226" />
                                    </div>
                                </div>
                            </Col>
                            <Col className='oee-dashboard-row-3-col-4'>
                                <div className='quality'>
                                    <span style={{fontSize: 18}}>Quality</span>
                                    <div className='quality-progress'>
                                        <DynamicProgress percent={stats?.quality || 0} color="#EB5757" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className='oee-dashboard-row-4'>
                            <div className='head'>
                                <span style={{fontSize: 18}}>OEE</span>
                                <span style={{ color: "#1E6EFE", fontSize: 18}}>{stats?.oeeFinal}%</span>
                            </div>
                            <div className='graph'>
                                {!stats?.oee ?
                                    <NoDataFound /> :
                                    <LineGraph data={stats?.oee} />
                                }
                            </div>
                        </Row>
                        <Row className='oee-dashboard-row-5'>
                            <Col span={11} className='oee-dashboard-row-5-col-1'>
                                <div className='output'>
                                    <div className='left'>
                                        <span className='head' style={{ fontSize: 18 }}>Output
                                            <div className='dflex flexColumn' style={{ fontSize: "13px" }}>
                                                <span className="boldText">Ideal Output</span>
                                                <span className='boldText' style={{ fontSize: 18 }}>
                                                    {stats?.idealOutput || 0}
                                                </span>
                                            </div>
                                        </span>
                                    </div>
                                        <div className="mid">
                                            <div className='graph-info'>
                                                {/* <div className='dot' style={{ backgroundColor: "#1E6EFE", width: "11px", height: "11px" }}></div> */}
                                                <span style={{color: 'color: #1E6EFE', fontWeight: 'bold', fontSize: 18}}>Goods</span>
                                                <span className="boldText" style={{color: '#1E6EFE', fontSize: 18}}>{stats?.goodOutput || 0}</span>
                                            </div>
                                            <div className='graph-info'>
                                                {/* <div className='dot' style={{ backgroundColor: "#EB5757", width: "11px", height: "11px" }}></div> */}
                                                <span style={{fontWeight: 'bold', fontSize: 18}}>Rejections</span>
                                                <span className="boldText" style={{color: '#EB5757', fontSize: 18}}> {stats?.totalRejections || 0}</span>
                                            </div>
                                        </div>
                                    <div className='graph'>
                                        <DynamicPiechart
                                            width={200}
                                            height={200}
                                            data={[
                                                { name: 'Good Output', value: stats?.goodOutput || 0, color: "#1E6EFE" },
                                                { name: 'Rejections', value: stats?.totalRejections || 0, color: "#EB5757" }
                                            ]}
                                            // data={oee_dashboard_output}
                                            dataKey="value"
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={13} className='oee-dashboard-row-5-col-2'>
                                <div className='shift-time'>
                                    <div className='left'>
                                        <div className='dflex flexColumn g10'>
                                        <span className='head' style={{fontSize: 16}}>Shift Time:</span>
                                        <span className='boldText' style={{ fontSize: 18 }}>{refineDateTime(stats?.plannedProductionTime * 60)}</span>
                                            <div className='dflex flexColumn' style={{ fontSize: "16px" }}>
                                                <span className="">Performance Downtime</span>
                                                <span >
                                                    {refineDateTime(stats?.downtimePerformance || 0)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                        <div className="mid">
                                            <div className='graph-info'>
                                                {/* <div className='dot' style={{ backgroundColor: "#1E6EFE", width: "11px", height: "11px" }}></div> */}
                                                <span className="boldText">Operating Time</span>
                                                <span className="boldText" style={{ fontSize: 18, color: '#1E6EFE' }}>{refineDateTime((stats?.productionTime - stats?.downtime) || 0)}</span>
                                            </div>
                                            <div className='graph-info'>
                                                {/* <div className='dot' style={{ backgroundColor: "#EB5757", width: "11px", height: "11px" }}></div> */}
                                                <span className="boldText">Availability Downtime</span>
                                                <span className="boldText" style={{ fontSize: 18, color: '#EB5757' }}>{convertSecsToTime(stats?.downtime || 0)}</span>
                                            </div>
                                            <div className='graph-info'>
                                                {/* <div className='dot' style={{ backgroundColor: "#1EA849", width: "11px", height: "11px" }}></div> */}
                                                <span className="boldText">Planned Downtime</span>
                                                <span className="boldText" style={{ fontSize: 18, color: '#1EA849' }}>{convertSecsToTime(stats?.plannedDowntime || 0)}</span>
                                            </div>
                                        </div>
                                    <div className='graph'>
                                        <DynamicPiechart
                                            width={200}
                                            height={200}
                                            // data={oee_dashboard_shiftTime}
                                            data={[
                                                { name: 'Operating Time', value: (stats?.productionTime - stats?.downtime) || 0, color: "#1E6EFE" },
                                                { name: 'Availability Downtime', value: stats?.downtime || 0, color: "#EB5757" },
                                                { name: 'Planned Downtime', value: stats?.plannedDowntime || 0, color: "#1EA849" },
                                            ]}
                                            dataKey="value" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="oee-dashboard-row-6">
                          {
                          /*
                            <Col className='oee-dashboard-row-6-col-1'>
                            <div className='shift-time'>
                              <span className='head'>Shift Time</span>
                              <span className='value'>{refineDateTime(stats?.plannedProductionTime * 60)}</span>
                            </div>
                          </Col> */
                        }
                        {!plant?.isGSK && (
                          <>
                            <Col className='oee-dashboard-row-6-col-2'>
                              <div className='average-speed'>
                                <span className='head'>Average Speed</span>
                                <span className='value'>{(stats?.averageSpeedForShift)?.toFixed(2) || 'N/A'}</span>
                              </div>
                            </Col>
                            <Col className='oee-dashboard-row-6-col-3'>
                              <div className='buffer'>
                                <span className='head'>Buffer</span>
                                <span className='value'>{stats?.buffer || 'N/A'}</span>
                              </div>
                            </Col>
                          </>
                        )}
                        </Row>
                    </> ): <></>}
            </div>
        </Spin>
    )
}
export default Dashboard